import ArticleBreadcrumbs from "@/components/Article/ArticleBreadcrumbs";
import ArticleBreadcrumbsLegacy from "@/components/Article/ArticleBreadcrumbsLegacy";

export default {
    components: {
        ArticleBreadcrumbs,
        ArticleBreadcrumbsLegacy
    },
    data() {
        return {
            seodata: {
                metaData: [],
                pageTitle: '',
                searchHeader: '',
                categoryDescription: '',
                breadcrumbs: [],
                canonicalUrl: ''
            }
        }
    }
}